import React, { Fragment } from 'react'

// third party components
import { Menu, Transition } from '@headlessui/react'

// images and icons
import MerchEditPage from '../MenuEditPage'
import ThreeDotIcon from 'assets/icons/three-dot-icon.svg?component'

// styles
import styles from './index.module.scss'

interface MenuSocialShareProps {
  studio: boolean
  metadata: boolean
  explorerURL: any
  merchToggle: boolean
  isCreatedNft: boolean
  setShowNftMeta: any
  setCreateMerchModal: any
  setRemoveMerchModal: any
  setOpenShareModal: any
}

const MenuEditNft = ({
  studio,
  metadata,
  merchToggle,
  explorerURL,
  isCreatedNft,
  setShowNftMeta,
  setCreateMerchModal,
  setRemoveMerchModal,
  setOpenShareModal,
}: MenuSocialShareProps) => {
  return (
    <div className="relative flex items-center">
      <Menu>
        <Menu.Button>
          <div className={`${styles.iconContainer} w-[30px] h-[30px]`}>
            <ThreeDotIcon alt="" />
          </div>
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Item>
            {({ active }) => (
              <div className="z-[1001]">
                <MerchEditPage
                  studio={studio}
                  metadata={metadata}
                  merchToggle={merchToggle}
                  explorerURL={explorerURL}
                  isCreatedNft={isCreatedNft}
                  setShowNftMeta={setShowNftMeta}
                  setCreateMerchModal={setCreateMerchModal}
                  setRemoveMerchModal={setRemoveMerchModal}
                  setOpenShareModal={setOpenShareModal}
                />
              </div>
            )}
          </Menu.Item>
        </Transition>
      </Menu>
    </div>
  )
}

export default MenuEditNft
